exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nlabel[data-v-4256be2a] {\n  margin-top: 7px !important;\n}\n", ""]);

// exports
